
export enum FilterMobilePageActionTypes {
	SHOW_FilterMobilePage = '@@filterMobilePage/SHOW',
	HIDE_SHOW_FilterMobilePage = '@@filterMobilePage/HIDE'
}

// Declare state types with `readonly` modifier to get compile time immutability.
export interface FilterMobilePageState {
	readonly isVisible: boolean
}
